import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { initFirestorter } from "firestorter";
import makeWebContext from "firestorter/web";
import { createContext, useContext } from "react";

import Config from "../config";
import AuthStore from "./auth";
import I18nStore from "./i18n";
import MultiversStore from "./multivers";

export * from "./auth";
export * from "./multivers";

try {
  const app = initializeApp(Config.firebase);
  const firestore = getFirestore(app);
  initFirestorter(makeWebContext({ firestore }));
} catch (error) {
  console.error(error);
}

export default class Store {
  i18n = new I18nStore(this);
  auth = new AuthStore(this);
  multivers = new MultiversStore(this);
}

const storeContext = createContext(new Store());
export const useStore = () => {
  const store = useContext(storeContext);
  if (!store) {
    // this is especially useful in TypeScript so you don't need to be checking for null all the time
    throw new Error("useStore must be used within a StoreProvider.");
  }
  return store;
};
